/**
 * 酒店房型后台：合作人员「类型」= 2 且「身份类型」= 4
 * 登录时在 sessionStorage 写入 cooperKind（类型）、cooperType（身份类型）
 */
export function isHotelCooperator() {
  const kind = window.sessionStorage.getItem('cooperKind')
  const identity = window.sessionStorage.getItem('cooperType')
  return kind === '2' && identity === '4'
}
